module.exports = __webpack_public_path__ + "static/media/Linje.b50ec1a1.m4a";